module.exports = __webpack_public_path__ + "static/media/delete-tool.9721291d.svg";